import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import './assets/font/font.css'
import waterfall from "vue-waterfall2";
//注册插件
// jquery
import $ from 'jquery'
Vue.prototype.$ = $

ElementUI.Select.computed.readonly = function () {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return !(this.filterable || this.multiple || !isIE) && !this.visible;
};
Vue.use(waterfall);
import wow from 'wowjs'

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
// amfe-flexible
import './utils/amfe-flexible.js'

document.addEventListener('contextmenu', e => e.preventDefault());

import Carousel3d from 'vue-carousel-3d';
Vue.use(Carousel3d);

import VideoPlayer from 'vue-video-player';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import "vue-video-player/node_modules/video.js/dist/video-js.css"
Vue.use(VideoPlayer)

// import Video from 'video.js'
// import 'video.js/dist/video-js.css'
// Vue.prototype.$video = Video

import 'animate.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './assets/swiper/swiper-bundle.min.css'
Vue.use(VueAwesomeSwiper)
Vue.prototype.$wow = wow

// 公共样式
import './assets/css/main.css'
import 'element-ui/lib/theme-chalk/index.css' //引用 element-ui 样式
import 'element-ui/lib/theme-chalk/display.css'

Vue.config.productionTip = false;
Vue.use(ElementUI);
// Vue.use(animate)

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");

// 百度统计
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?af02ec13e6f6d28a935c1f51d6fb431b";
  var s = document.getElementsByTagName("script")[0]; 
  // console.log(s.parentNode.insertBefore(hm, s));
  s.parentNode.insertBefore(hm, s);
})();